import { connect } from 'react-redux';
import countryProfilesShow from 'components/country-profiles/show';
import {
  getCountryProfileReport,
  getCountryInfo,
  getCountries,
  setCountry,
  getCompositesAverage,
  getCategoriesAverage,
  getSubcategoriesAverage,
  getIndicatorsAverage,
  setDataFilters,
  getGraphTypeData
} from 'redux-modules/country-profiles';
import { getActiveYears } from 'redux-modules/data';
import { getCountryData } from 'selectors/country-profiles';
import { setModalContent } from 'redux-modules/modal';
import { getTotalAssetments } from 'selectors/common';

const mapStateToProps = (state) => ({
  country: state.countryProfile.country,
  countries: state.countryProfile.countries,
  info: state.countryProfile.info,
  data: getCountryData(state),
  dataReport: state.countryProfile.dataReport,
  years: state.countryProfile.years,
  compareData: state.countryProfile.compareData,
  filters: state.countryProfile.filters,
  sectors: state.countryProfile.sectors,
  graphTypeData: state.countryProfile.graphTypeData,
  totalAssestments: getTotalAssetments(state),
  averages: state.countryProfile.averages,
  activeYears: state.data.activeYears
});

const mapDispatchToProps = (dispatch) => ({
  getCountryInfo: (iso) => dispatch(getCountryInfo(iso)),
  getCountries: () => dispatch(getCountries()),
  getActiveYears: () => dispatch(getActiveYears()),
  getGraphData: (type, year) => dispatch(getGraphTypeData(type, year)),
  getCountryProfileReport: (iso, years) => dispatch(getCountryProfileReport(iso, years)),
  setCountry: (country) => dispatch(setCountry(country)),
  setModalContent: (content) => dispatch(setModalContent(content)),
  setDataFilters: (filters) => dispatch(setDataFilters(filters)),
  getAverages: () => {
    dispatch(getCompositesAverage());
    dispatch(getCategoriesAverage());
    dispatch(getSubcategoriesAverage());
    dispatch(getIndicatorsAverage());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(countryProfilesShow);



// WEBPACK FOOTER //
// ./app/containers/country-profiles/show.js